import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class LoaderService {


  show = new Subject<boolean>();

  constructor() {

  }


}
